// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__NXHuV","header":"ReportDetails_header__HtJ_3","title":"ReportDetails_title__3HmIx","left":"ReportDetails_left__fOBvU"};